<template></template>
<script>
    export default {
        name: "remove-empty-parameters",
        props: ['header'],
        mounted() {
            this.changeURL();
        },
        methods: {
            changeURL() {
                let query = window.location.search;
                query = query.replace(/[^?=&]+=(&|$)/g, "").replace(/&$/, "");
                history.pushState({}, "Searching query", this.header + query);
            },
        }
    }
</script>
